import useEditCharacterArmourLocation from '../composables/useEditCharacterArmourLocation'

//-------------------------------------------
// update character armour-locations harness
//-------------------------------------------
export default async function useUpdateCharacterArmourLocationsHarness(changed_armour_locations) {
  const promises = changed_armour_locations.map((armourLocation) =>
    useEditCharacterArmourLocation(armourLocation),
  )

  return Promise.all(promises)
}
